import script from "./Internacao.vue?vue&type=script&setup=true&lang=js"
export * from "./Internacao.vue?vue&type=script&setup=true&lang=js"

import "./Internacao.vue?vue&type=style&index=0&id=39910614&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontendRegua\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39910614"]])

export default __exports__